import React, { useEffect, useRef } from 'react';
import { Animated, StyleSheet, View, Easing, DimensionValue, Text } from 'react-native';
import { useThemeContext } from '../../contexts';
import { createSpinnerInner, createSpinnerOuter } from '../../data/spinner/spinner-svg';

/**
 * Spinner component
 *
 * @return {*}
 */
const Spinner: React.FC = () => {
  const { theme } = useThemeContext();

  const spinnerInner = createSpinnerInner(theme);
  const spinnerOuter = createSpinnerOuter(theme);

  const rotationOuter = useRef(new Animated.Value(0)).current;
  const rotationInner = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const spinOuterAnimation = Animated.loop(
      Animated.timing(rotationOuter, {
        toValue: 1,
        duration: 1500,
        useNativeDriver: false,
        easing: Easing.linear
      })
    );

    const spinInnerAnimation = Animated.loop(
      Animated.timing(rotationInner, {
        toValue: 1,
        duration: 1500,
        useNativeDriver: false,
        easing: Easing.linear
      })
    );

    spinOuterAnimation.start();
    spinInnerAnimation.start();

    return () => {
      spinOuterAnimation.stop();
      spinInnerAnimation.stop();
    };
  }, [rotationOuter, rotationInner]);

  const spinOuter = rotationOuter.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '-360deg']
  });

  const spinInner = rotationInner.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg']
  });

  return (
    <View style={styles.spinnerContainer}>
      <Animated.View style={{ transform: [{ rotate: spinOuter }] }}>{spinnerOuter}</Animated.View>
      <Animated.View
        style={{
          position: 'absolute',
          transform: [{ rotate: spinInner }]
        }}>
        {spinnerInner}
      </Animated.View>
    </View>
  );
};

interface SpinnerProps {
  text?: string;
}

export const FullScreenSpinner: React.FC<SpinnerProps> = ({ text }) => {
  return (
    <View style={styles.container}>
      <Spinner />
      <Text style={styles.text}>{text}</Text>
    </View>
  );
};

export default Spinner;

const styles = StyleSheet.create({
  spinnerContainer: {
    width: 62,
    height: 62,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  logo: {
    width: 48,
    height: 48
  },
  container: {
    flex: 1,
    height: '100vh' as DimensionValue,
    width: '100vw' as DimensionValue,
    justifyContent: 'center',
    alignItems: 'center'
  },
  customSize: {
    transform: [{ scale: 1.5 }]
  },
  loader: {
    width: 48,
    height: 48,
    borderRadius: 24,
    borderTopWidth: 3,
    borderRightWidth: 3,
    borderColor: '#BA0020',
    borderRightColor: 'transparent'
  },
  text: {
    fontSize: 18,
    fontWeight: 700,
    margin: 50
  }
});
